import { Typography } from '@mui/material';
import { Box, styled } from '@mui/system';

export const PKDContainer = styled(Box)(({ theme, marginTop }) => ({
  display                        : 'grid',
  maxWidth                       : '968px',
  margin                         : '0 auto',
  gridTemplateColumns            : '1fr 2fr',
  gridGap                        : '34px',
  marginTop,
  [theme.breakpoints.down('sm')] : {
    gridTemplateColumns : '1fr',
    padding             : '16px',
  },
}));
export const ImageWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.only('xs')] : {
    width        : '100%',
    height       : 'auto',
    aspectRatio  : '1/1',
    overflow     : 'hidden',
    borderRadius : '20px',
  },
}));

export const FormImage = styled('img')(({ theme }) => ({
  width                          : '298px',
  borderRadius                   : '20px',
  [theme.breakpoints.only('xs')] : {
    width       : '100%',
    aspectRatio : 'auto',
    objectFit   : 'fill',
  },
}));

export const FormTitle = styled(Typography)(({ theme, textAlign }) => ({
  fontFamily : 'Montserrat',
  fontSize   : '32px',
  fontWeight : 700,
  lineHeight : '42px',
  color      : theme.palette.primary.greenPKD,
  textAlign,
}));

export const FormDescription = styled(Typography)(({ theme }) => ({
  fontFamily : 'Montserrat',
  fontSize   : '16px',
  lineHeight : '24px',
  color      : theme.palette.primary.gray8,
}));

export const FormRow = styled(Box, {
  shouldForwardProp : (prop) => prop !== 'gridGap',
})(({ theme, cols = '2', gridGap = '34px' }) => ({
  display                        : 'grid',
  gridTemplateColumns            : `repeat(${cols}, 1fr)`,
  gridGap,
  [theme.breakpoints.only('xs')] : {
    gridTemplateColumns : '1fr',
    padding             : 0,
  },
}));
